import { DeviceSearchRow, PropertySearchRow, SearchRow } from 'common';
import { HttpService } from './http.service';

export class SearchService extends HttpService {
  search(text: string, signal?: AbortSignal): Promise<(DeviceSearchRow | PropertySearchRow)[]> {
    return this.send<any[]>({
      url: '/Search',
      query: { text },
      method: 'get',
      signal,
    }).then((rows) => rows.map((r) => SearchRow.Hydrate(r)));
  }
}
